import Vue from 'vue';
import guide from './main';
import { getLocalStorage, setLocalStorage } from '../../utils/util';

const RTXPC_GUIDE_KEY = 'rt-xpc-guide-first-visible';
let instance;

const GuideConstructor = Vue.extend(guide);

const defaultCallback = () => {};

const initInstance = () => {
  instance = new GuideConstructor({
    el: document.createElement('div')
  });
  instance.callback = defaultCallback;
};

/**
 * 展示引导
 * @param {Object} options
 *                   {Array} data 需要展示引导的数据
 *                     {Number} index 引导的序号
 *                     {String} title 引导展示的标题
 *                     {String} content 引导展示的内容
 *                     {HTMLElment} target 引导展示的标记元素
 *                   {String} key 存储在localStorage的key
 *                   {String} isForce 是否强制展示引导
 */
function showGuide ({ data = [], key, isForce = false, callback, ...options }) {
  if (!instance) {
    initInstance();
  }
  let localKey = RTXPC_GUIDE_KEY;
  if (key) {
    localKey += `-` + key;
  }

  const hasVisibled = getLocalStorage(localKey);
  const innerCallBack = (opt) => {
    instance.visible = false;
    if (callback && typeof callback === 'function') {
      callback(opt);
    }
    setLocalStorage(localKey, true);
  }

  if (!hasVisibled || isForce) {
    if (data.length > 0) {
      instance.data = data.sort((a, b) => a.index - b.index);
      Object.keys(options).forEach(k => {
        instance[k] = options[k];
      });
      instance.callback = innerCallBack;

      document.body.appendChild(instance.$el);

      Vue.nextTick(() => {
        instance.visible = true;
      });
    }
  }
}

export default showGuide;

export { showGuide };



// WEBPACK FOOTER //
// ./~/vue-xpc/src/components/guide/index.js